/**
 * The phone layout's in-memory caches (dashboard summaries, chart data, the
 * Control Panel snapshot) register their clear function here, so logging
 * out clears them all. Nothing pour-related is kept in localStorage: site
 * phones may be shared.
 */

type ClearFn = () => void;

const clearFns = new Set<ClearFn>();

/** Register a cache's clear function; returns an unregister function. */
export const registerMobileCacheClear = (fn: ClearFn): (() => void) => {
  clearFns.add(fn);
  return () => {
    clearFns.delete(fn);
  };
};

/** Clear every registered cache. One failing cache does not stop the rest. */
export const clearMobileCaches = (): void => {
  clearFns.forEach((fn) => {
    try {
      fn();
    } catch (error) {
      console.error('Failed to clear a mobile cache:', error);
    }
  });
};
